import React, {useCallback} from 'react';
import {FormFieldOption} from '@src/@types/components/Form';
import ErrorRepresentation from '@src/components/ErrorRepresentation/ErrorRepresentation';
import Translate from '@src/components/Translate/Translate';
import useUniqueId from '@src/hooks/useUniqueId';
import CustomSelect from '@src/components/Fields/CustomSelect';
import useConfigValue from '@src/hooks/useConfigValue';
import config from '@src/helpers/config';
import {notNull} from '@src/helpers/ts/notNull';
import {ConfigKeys} from '@src/@types/services/Config/ConfigKeys';

const wrapperStyles = {maxWidth: '600px'} as React.CSSProperties;

export default function OrderProductsListenOnlyTheseDepartmentsSoundSetting(props: {
    options?: FormFieldOption[],
    error?: Error | null,
    isLoading: boolean,
    className?: string,
}) {
    const id = useUniqueId();
    const label = `SoundsSettings.notifications.new-order-product.play-when-its-has-one-of-these-departments`;
    const name: ConfigKeys = `settings.notifications.new-order-product.only-these-departments`;
    const shouldBeDisabled = useConfigValue<boolean>(
            'settings.notifications.new-order-product.only-my-departments',
            true
    );
    const value = useConfigValue<number[]>(name, []);
    const onChange = useCallback((ids?: (string | number | null)[]) => {
        if (!shouldBeDisabled) {
            config().set(name, (ids ?? []).filter(notNull));
        }
    }, [name, shouldBeDisabled]);

    if (props.error) {
        return <ErrorRepresentation
                error={props.error}
                outsideContainer
                className="mb-0"
        />;
    }

    return <div style={wrapperStyles} className={props.className}>
        <Translate<HTMLLabelElement>
                message={label}
                tag="label"
                htmlFor={id}
        />
        <CustomSelect<true>
                inputId={id}
                label={label}
                options={props.options}
                onChange={onChange}
                value={value}
                isLoading={props.isLoading}
                disabled={shouldBeDisabled}
                clearable
                multiple
        />
    </div>;
}
